import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Fired when a user successfully updates an existing skill',
  name: 'skill_updated',
  params: [
    {
      description: 'ID of the updated skill',
      name: 'skill_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Current scope after update',
      name: 'scope',
      required: true,
      type: 'enum',
      values: ['private', 'workspace'],
    },
  ],
};

export default META;
